import GeoJSON from 'ol/format/GeoJSON';
import { addFeaturesToLayer } from 'utils/map/layers';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';

import { STATUS_COLORS } from 'consts/mapConfig';

export const addMissionApprovals = (layer, approvals) => {
  if (!layer) return;
  const parser = new GeoJSON();
  const features = [];
  for (const oneApproval of approvals) {
    const approval = oneApproval.mission
      ? { ...oneApproval.mission, dtm_status: oneApproval.status }
      : oneApproval;
    for (let i = 0; i < approval.legs.features.length; i += 1) {
      const feature = parser.readFeature(approval.legs.features[i], {
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:3857',
      });
      feature.setId(`${approval.uid}-#${i + 1}`);
      feature.setProperties({
        status: approval.dtm_status,
        detail: 'missionApproval',
      });
      feature.setStyle(
        getBasicMissionStyle({
          status: approval.dtm_status,
        })
      );
      features.push(feature);
    }
  }
  addFeaturesToLayer(layer, features);
};

const getBasicMissionStyle = mission => {
  const { status } = mission;
  const polygonStyle = new Style({
    stroke: new Stroke({
      color: STATUS_COLORS[status.toLowerCase()]?.stroke,
      width: 1,
    }),
    fill: new Fill({
      color: STATUS_COLORS[status.toLowerCase()]?.fill,
    }),
  });
  return polygonStyle;
};
